import { render, staticRenderFns } from "./Kichen.vue?vue&type=template&id=1dfa1167&scoped=true&"
import script from "./Kichen.vue?vue&type=script&lang=js&"
export * from "./Kichen.vue?vue&type=script&lang=js&"
import style0 from "./Kichen.vue?vue&type=style&index=0&id=1dfa1167&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa1167",
  null
  
)

export default component.exports